import React from 'react';
import { useTranslation } from 'react-i18next';

import TablesToggle from '../../../shared-components/tables-toggle/TablesToggle';

import ByTransactionAccount from './ByTransactionAccount';
import RevenueByMonthAccount from './RevenueByMonthAccount';

/**
 * Revenue table component
 * @returns
 */
function Revenue() {
   const { t } = useTranslation('account');
  return (
    <div>
      <TablesToggle
        tabs={[
          { label: t('byTransaction'), content: <ByTransactionAccount /> },
          { label: t('byMonth'), content: <RevenueByMonthAccount /> },
        ]}
        defaultActive={t('byTransaction')}
      />
    </div>
  );
}

export default Revenue;
